import initialState from "../initialState";

import {
  AI_RESPONSE_ARE_LOADING,
  AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR,
  AI_RESPONSE_HAVE_LOADED,
  AI_QUESTION_ERROR_MESSAGE_RAISED,
  AI_RESPONSE_CLOSE_MODAL,
} from "../actions/actionTypes";

export default function askQuestionReducer(
  state = initialState.askQuestionReducer,
  action
) {
  switch (action.type) {
    case AI_RESPONSE_ARE_LOADING: {
      return {
        ...state,
        aIResponseAreLoading: true,
        aiQuestionAreLoadedWithError: false,
        response: [],
      };
    }

    case AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR: {
      return {
        ...state,
        aIResponseAreLoading: false,
        aiQuestionAreLoadedWithError: true,
        response: action.response,
      };
    }

    case AI_RESPONSE_HAVE_LOADED: {
      return {
        ...state,
        aIResponseAreLoading: false,
        aiQuestionAreLoadedWithError: false,
        response: action.response,
      };
    }

    case AI_QUESTION_ERROR_MESSAGE_RAISED: {
      return {
        ...state,
        aiQuestionErrorMessageRaised: action.aiQuestionErrorMessage,
      };
    }

    case AI_RESPONSE_CLOSE_MODAL: {
      return {
        ...state,
        aIResponseAreLoading: false,
        aiQuestionAreLoadedWithError: false,
        response: [],
        aiQuestionErrorMessage: "",
      };
    }

    default: {
      return state;
    }
  }
}
